(function ($) {

  enquire.register("screen and (min-width:768px)", {
    match: function () {
      var e = $('#page-background');
      if (e.length) {
        $('body').css(
          {
            backgroundImage: 'url(' + e.attr('data-url') + ')',
            backgroundSize: 'cover',
          }
        );
      }

      if ($('body.home.page').length) {
        var f = $('#fullpage');
        if (f.length) {
          f.fullpage({
            verticalCentered: false,
            anchors: ['firstPage', 'secondPage'],
            menu: '#menu',
            css3: true,
            scrollingSpeed: 1000
          });
        }
      }
    }
  });

  enquire.register("screen and (max-width:768px)", {
    match: function () {
      if ($('body.home.page').length) {
        var f = $('#fullpage');
        if (f.length) {
          f.fullpage({
            verticalCentered: false,
            anchors: ['firstPage', 'secondPage'],
            menu: '#menu',
            css3: true,
            scrollingSpeed: 1000,
            autoScrolling: false
          });
        }
      }
    }
  });

  if (!$('body.home.page').length) {
    $('body').imagesLoaded(function () {
      if ($(window).height() === $(document).height()) {
        $('footer').css('position', 'absolute');
      } else {
        $('footer').css('position', 'relative');
      }
      $(window).on("resize", function (event) {
        if ($(window).height() === $(document).height()) {
          $('footer').css('position', 'absolute');
        } else {
          $('footer').css('position', 'relative');
        }
      });
    });
  }

  $.scrollUp({
    animation: 'fade',
    scrollImg: {
      active: true,
      type: 'background'
    }
  });

  if ($('body.home.page').length) {
    $('#maximage').maximage({
      fillElement: '#home-section-1 .content-wrapper',
      backgroundSize: 'contain'
    });
  }

  $('.do-popup-link').magnificPopup({
    type: 'iframe',
    closeBtnInside: true,
    fixedContentPos: true,
  });

   // bind change event to select
   $('.selectpicker').on('change', function () {
     var url = $(this).find(':selected').data('url');
     console.log(url);
     if (url) {
        window.location = url;
     }
     return false;
   });

})(jQuery); // Fully reference jQuery after this point.






